// extracted by mini-css-extract-plugin
export var displayNone = "_tx-6";
export var imgContainer = "_tx-2";
export var overflowHidden = "_tx-3";
export var productInfoCardButtonContainer = "_tx-5";
export var productTitleText = "_tx-4";
export var rightArrow = "_tx-1";
export var rightArrowContainer = "_tx-0";